import { useCallback } from "react";

function useProcessUiSchema() {
  function processUiSchema(schema: any, element: any, filterData: any) {
    if (!schema || !filterData) return schema;

    // Clonamos el schema para no mutar el original
    const newSchema = { ...schema };

    // Recorremos las claves de filterData
    Object.keys(filterData).forEach((key) => {
      if (newSchema[key]) {
        const originalField = newSchema[key];
        const originalUiOptions = originalField["ui:options"] || {};

        newSchema[key] = {
          ...originalField,
          "ui:options": {
            ...originalUiOptions,
            filters: filterData[key],
          },
        };
      }
    });

    return newSchema;
  }

  return useCallback(
    (schema: any, element: any, filterData: any) => {
      return processUiSchema(schema, element, filterData);
    },
    []
  );
}

export default useProcessUiSchema;
